import gql from "graphql-tag";

const GET_ANALYTICS = gql`
  query(
    $months: Int
    $startDate: String
    $endDate: String
    $timezoneOffset: Int
    $topSpendingsLimit: Int
  ) {
    monthlySpending(
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      month
      total
      type
      currency {
        id
        name
      }
    }
    categorySpending(
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      total
      category {
        id
        name
        type
      }
      currency {
        id
        name
      }
    }
    monthlyCategorySpending(
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      month
      total
      category {
        id
        name
        type
      }
      currency {
        id
        name
      }
    }
    noteSpending(
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      note
      total
      count
      type
      currency {
        id
        name
      }
    }
    topSpendings(
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
      limit: $topSpendingsLimit
    ) {
      id
      amount
      note
      date
      category {
        id
        name
        type
      }
      currency {
        id
        name
      }
    }
    currencySummary(timezoneOffset: $timezoneOffset) {
      currentIncome
      currentExpense
      previousIncome
      previousExpense
      currency {
        id
        name
      }
    }
  }
`;

export const GET_CATEGORY_TREND = gql`
  query(
    $categoryId: ID!
    $months: Int
    $startDate: String
    $endDate: String
    $timezoneOffset: Int
  ) {
    monthlySpending(
      categoryId: $categoryId
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      month
      total
      type
      currency {
        id
        name
      }
    }
  }
`;

export const GET_SPENDING_DETAILS = gql`
  query(
    $categoryId: ID
    $note: String
    $currencyId: ID
    $categoryType: String
    $months: Int
    $startDate: String
    $endDate: String
    $timezoneOffset: Int
    $offset: Int
    $limit: Int
  ) {
    spendings(
      categoryId: $categoryId
      note: $note
      currencyId: $currencyId
      categoryType: $categoryType
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
      offset: $offset
      limit: $limit
    ) {
      id
      amount
      note
      date
      category {
        id
        name
        type
      }
      currency {
        id
        name
      }
    }
  }
`;

export const GET_AMOUNT_HISTOGRAM = gql`
  query(
    $categoryId: ID
    $note: String
    $currencyId: ID
    $categoryType: String
    $months: Int
    $startDate: String
    $endDate: String
    $timezoneOffset: Int
  ) {
    amountHistogram(
      categoryId: $categoryId
      note: $note
      currencyId: $currencyId
      categoryType: $categoryType
      months: $months
      startDate: $startDate
      endDate: $endDate
      timezoneOffset: $timezoneOffset
    ) {
      rangeStart
      rangeEnd
      count
    }
  }
`;

export default GET_ANALYTICS;
